export const ADD_PLAN = "ADD_PLAN"
export const ADD_PLAN_SUCCESSFUL = "ADD_PLAN_SUCCESSFUL"
export const ADD_PLAN_FAILED = "ADD_PLAN_FAILED"
export const RESET_PAY_INFO = "RESET_PAY_INFO"
export const API_ERROR = "API_ERROR"
export const RESET_RESPONSE_MESSAGE = "RESET_RESPONSE_MESSAGE"